<div class="category-item" [style]="{'background-color': selected ? 'rgba(0, 0, 0, 0.2)' : 'transparent'}">
  <exercice-category-thumbnail *ngIf="category?.id" [data]="category" [hideText]="true"></exercice-category-thumbnail>
  <div *ngIf="!category?.id">{{ 'all_items' | translate }}</div>
  <div *ngIf="category?.id" class="category-name">{{ category?.name }}</div>
</div>
